/**
 * Configuration globale du site ZIG Investment
 * Contient les informations de contact, réseaux sociaux, et métadonnées
 */
export const siteConfig = {
    /* Nom et domaine */
    name: 'ZIG Investment',
    domain: 'https://www.ziginvestment.com',
    tagline: 'Écosystème Tech & Finance',

    /* Contact */
    contact: {
        phones: ['+509 40 12 8282'],
        emails: ['info@ziginvestment.com'],
        whatsapp: '+50940128282',
        address: {
            street: 'Rue 7 E',
            city: 'Cap-Haïtien',
            country: 'Haïti',
            full: 'Rue 7 E, Cap-Haïtien, Haïti',
        },
    },

    /* Réseaux sociaux */
    social: {
        facebook: 'https://www.facebook.com/ziginvestment',
        instagram: 'https://www.instagram.com/ziginvestment',
        linkedin: 'https://www.linkedin.com/company/ziginvestment',
        twitter: 'https://twitter.com/ziginvestment',
        youtube: 'https://www.youtube.com/@ziginvestment',
        tiktok: 'https://www.tiktok.com/@ziginvestment',
    },

    contruct: {
        kolabtech: 'https://kolabtech.com',
    },

    /* Domaines de l'écosystème */
    domains: [
        'Finance digitale',
        'Technologie',
        'E-commerce',
        'Logistique',
        'Connectivité',
        'Média',
        'Santé',
        'Agriculture',
        'Immobilier',
        'Éducation',
    ],

    /* Métadonnées SEO par défaut */
    seo: {
        defaultTitle: 'ZIG Investment — Écosystème Tech & Finance',
        titleTemplate: '%s | ZIG Investment',
        defaultDescription:
            'ZIG Investment est un écosystème innovant de technologie et finance en Haïti. Créons l\'espoir, construisons l\'avenir.',
        ogImage: '/zig.jpeg',
        twitterHandle: '@ziginvestment',
    },
} as const;
